<template>
  <Content class="success-card">
    <Card>
      <h1>
        {{ $t("success") }}
      </h1>
      <p>
        {{ $t("application_was_sent") }}
      </p>
      <Button @click="goBack">Return Home</Button>
    </Card>
  </Content>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="scss">
.success-card {
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  .ivu-card {
    height: 100%;
    flex: 1;
    display: flex;
  }
  .ivu-card-body {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    row-gap: 1rem;
  }
}
</style>
